import { getCatchUp } from './api/Api'
import { appSettings } from './AppSettings'

// route helpers
export const getBrandData = (page, brandName, autoPlay) => {
  return new Promise(resolve => {
    const brands = appSettings.brands
    let brandIdx = -1
    if (brandName) {
      brandIdx = brands.findIndex(br => br.brandName.toLowerCase() === brandName.toLowerCase())
    } else {
      brandName = brands[0].brandName
      brandIdx = brands.findIndex(br => br.brandName.toLowerCase() === brandName.toLowerCase())
    }

    if (brandIdx === -1) {
      brandIdx = 0
    }

    appSettings.currentBrand = brands[brandIdx]

    page.data = {
      index: brandIdx,
      brand: brands[brandIdx],
      autoPlay: autoPlay ? true : false,
    }

    resolve(true)
  })
}

export const getCatchUpData = (page, brandName) => {
  return new Promise(resolve => {
    const brands = appSettings.brands
    let brandIdx = -1

    if (brandName) {
      brandIdx = brands.findIndex(br => br.brandName.toLowerCase() === brandName.toLowerCase())
    } else {
      brandName = brands[0].brandName
      brandIdx = brands.findIndex(br => br.brandName.toLowerCase() === brandName.toLowerCase())
    }

    if (brandIdx === -1) {
      brandIdx = 0
    }

    appSettings.currentBrand = brands[brandIdx]

    getCatchUp(appSettings.currentBrand).then(response => {
      page.data = {
        index: brandIdx,
        brand: brands[brandIdx],
        items: response.items,
      }

      resolve(true)
    })
  })
}
